import { Button, Tooltip } from "@fluentui/react-components";
import { AdminRowAction } from "./AdminListPage.types";
import { useAdminTableActionsStyles } from "./AdminTableActions.styles";

interface AdminTableActionsProps<T> {
  item: T;
  actions: AdminRowAction<T>[];
}

export const AdminTableActions = <T,>(
  props: AdminTableActionsProps<T>,
): JSX.Element => {
  const { item, actions } = props;
  const styles = useAdminTableActionsStyles();

  return (
    <div className={styles.container}>
      {actions.map((action) => {
        const isItemVisible = action.isVisible?.(item) ?? true;
        if (!isItemVisible) {
          return (
            <div
              key={action.tooltip}
              className={styles.actionSlotHidden}
              aria-hidden="true"
            />
          );
        }

        if (action.isNonInteractive) {
          return (
            <Tooltip
              key={action.tooltip}
              content={action.tooltip}
              positioning="below-start"
              relationship="label"
              withArrow
            >
              <span
                className={styles.nonInteractiveBadge}
                tabIndex={-1}
                aria-label={action.tooltip}
              >
                {action.icon}
              </span>
            </Tooltip>
          );
        }

        const isDisabled = action.disabled?.(item) ?? false;

        return (
          <Tooltip
            key={action.tooltip}
            content={action.tooltip}
            positioning="below-start"
            relationship="label"
            withArrow
          >
            <Button
              className={styles.actionButton}
              icon={action.icon}
              onClick={() => action.onClick?.(item)}
              disabled={isDisabled}
              appearance="subtle"
              aria-label={action.tooltip}
            />
          </Tooltip>
        );
      })}
    </div>
  );
};
